import {
  GET_DASHBOARD_COMBINE_LEADERBOARD_LOADING,
  GET_DASHBOARD_COMBINE_LEADERBOARD_SUCCESS,
  GET_DASHBOARD_COMBINE_LEADERBOARD_FAIL,
} from "../../../constant/actionTypes";

const dashboardCombineLeaderboardReducer = (
  state = {
    loading: true,
  },
  action
) => {
  switch (action.type) {
    case GET_DASHBOARD_COMBINE_LEADERBOARD_LOADING: {
      let obj = {
        loading: true,
      };
      return obj;
    }
    case GET_DASHBOARD_COMBINE_LEADERBOARD_SUCCESS: {
      let obj = {
        loading: false,
        data: action.response,
      };
      return obj;
    }
    case GET_DASHBOARD_COMBINE_LEADERBOARD_FAIL: {
      let obj = {
        loading: false,
        status: action.response,
      };
      return obj;
    }
    default:
      return state;
  }
};
export default dashboardCombineLeaderboardReducer;
